import { ActionsUnion, EActionType } from '../points.actions';
import { TPointsByWorkspace } from '../points.model';
import { addAllSortedPointIds } from './addAllSortedPointIds';
import { addAttachment } from './addAttachment';
import { addPoint } from './addPoint';
import { addWorkspaceSortedPointIds } from './addWorkspaceSortedPointIds';
import { deletePoint } from './deletePoint';
import { deletePoints } from './deletePoints';
import { deselectWorkspacePoints } from './deselectWorkspacePoints';
import { filterAllPoints } from './filterAllPoints';
import { removeAttachments } from './removeAttachments';
import { removeWorkspacePoints } from './removeWorkspacePoints';
import { selectWorkspacePoints } from './selectWorkspacePoints';
import { setAllPoints } from './setAllPoints';
import { setPoints } from './setPoints';
import { togglePointsSelection } from './toggle-points-selection';
import { toggleAllPointsSelection } from './toggleAllPointsSelection';
import { togglePointSelection } from './togglePointSelection';
import { updatePointCustomFieldBulk } from './update-point-custom-field-bulk';
import { updatePoint } from './updatePoint';
import { updatePointAssignees } from './updatePointAssignees';
import { updatePointComment } from './updatePointComment';
import { updatePointCustomFields } from './updatePointCustomFields';
import { updatePointDescription } from './updatePointDescription';
import { updatePointFlag } from './updatePointFlag';
import { updatePointPin } from './updatePointPin';
import { updatePointPriority } from './updatePointPriority';
import { updatePointStatus } from './updatePointStatus';
import { updatePointTags } from './updatePointTags';
import { updatePointTitle } from './updatePointTitle';
import { updatePoints } from './updatePoints';
import { updatePointsAssignees } from './updatePointsAssignees';
import { updatePointsCustomFields } from './updatePointsCustomFields';
import { updatePointsPriorities } from './updatePointsPriorities';
import { updatePointsTags } from './updatePointsTags';

export const initialState: TPointsByWorkspace = {};

export function pointsReducer(
  oldState: TPointsByWorkspace = initialState,
  action: ActionsUnion,
): TPointsByWorkspace {
  switch (action.type) {
    case EActionType.SET_POINTS:
      return setPoints(oldState, action);

    case EActionType.SET_ALL_POINTS:
      return setAllPoints(oldState, action);

    case EActionType.FILTER_ALL_POINTS:
      return filterAllPoints(oldState, action);

    case EActionType.CLEAR_POINTS:
      return {};

    case EActionType.REMOVE_WORKSPACE_POINTS:
      return removeWorkspacePoints(oldState, action);

    case EActionType.ADD_POINT:
      return addPoint(oldState, action);

    case EActionType.UPDATE_POINT:
      return updatePoint(oldState, action);
    case EActionType.UPDATE_POINTS:
      return updatePoints(oldState, action);

    case EActionType.DELETE_POINT:
      return deletePoint(oldState, action);

    case EActionType.DELETE_POINTS:
      return deletePoints(oldState, action);

    case EActionType.SELECT_WORKSPACE_POINTS:
      return selectWorkspacePoints(oldState, action);

    case EActionType.DESELECT_WORKSPACE_POINTS:
      return deselectWorkspacePoints(oldState, action);

    case EActionType.TOGGLE_ALL_POINTS_SELECTION:
      return toggleAllPointsSelection(oldState, action);

    case EActionType.TOGGLE_POINT_SELECTION:
      return togglePointSelection(oldState, action);

    case EActionType.TOGGLE_POINTS_SELECTION:
      return togglePointsSelection(oldState, action);

    case EActionType.UPDATE_POINT_STATUS:
      return updatePointStatus(oldState, action);

    case EActionType.UPDATE_POINT_FLAG:
      return updatePointFlag(oldState, action);

    case EActionType.UPDATE_POINT_PRIORITY:
      return updatePointPriority(oldState, action);

    case EActionType.UPDATE_POINTS_PRIORITIES:
      return updatePointsPriorities(oldState, action);

    case EActionType.UPDATE_POINT_TITLE:
      return updatePointTitle(oldState, action);

    case EActionType.UPDATE_POINT_DESCRIPTION:
      return updatePointDescription(oldState, action);

    case EActionType.UPDATE_POINT_TAGS:
      return updatePointTags(oldState, action);

    case EActionType.UPDATE_POINT_ASSIGNEES:
      return updatePointAssignees(oldState, action);

    case EActionType.UPDATE_POINTS_TAGS:
      return updatePointsTags(oldState, action);

    case EActionType.UPDATE_POINTS_ASSIGNEES:
      return updatePointsAssignees(oldState, action);

    case EActionType.UPDATE_POINT_CUSTOM_FIELD:
      return updatePointCustomFields(oldState, action);

    case EActionType.UPDATE_POINT_CUSTOM_FIELD_BULK:
      return updatePointCustomFieldBulk(oldState, action);

    case EActionType.UPDATE_POINTS_CUSTOM_FIELDS:
      return updatePointsCustomFields(oldState, action);

    case EActionType.UPDATE_POINT_PIN:
      return updatePointPin(oldState, action);

    case EActionType.ADD_IMAGE:
    case EActionType.ADD_IMAGE_360:
    case EActionType.ADD_VIDEO:
    case EActionType.ADD_FILE:
    case EActionType.REPLACE_IMAGE:
      return addAttachment(oldState, action);

    case EActionType.REMOVE_ATTACHMENTS:
      return removeAttachments(oldState, action);

    case EActionType.UPDATE_POINT_COMMENT:
      return updatePointComment(oldState, action);

    case EActionType.ADD_WORKSPACE_SORTED_POINT_IDS:
      return addWorkspaceSortedPointIds(oldState, action);

    case EActionType.ADD_ALL_SORTED_POINT_IDS:
      return addAllSortedPointIds(oldState, action);

    default:
      return oldState;
  }
}
